const DEFAULT_PERSONEL_DATA = {
  hero: {
    badge: 'ISO 27001 UYUMLU PERSONEL YÖNETİMİ',
    badge_en: 'ISO 27001 COMPLIANT PERSONNEL MANAGEMENT',
    title: 'Personel Güvenliği ve Yönetimi',
    title_en: 'Personnel Security & Management',
    description:
      'Çalışan rolleri, yetkilendirme ve güvenlik farkındalığı süreçlerini ISO 27001 standartlarına uygun olarak tek bir merkezden dijitalleştirin.',
    description_en:
      'Digitize employee roles, authorization, and security awareness processes in full compliance with ISO 27001 standards from a single center.',
    primaryButtonText: 'Ücretsiz Deneyin',
    primaryButtonText_en: 'Try for Free',
    secondaryButtonText: 'Dokümantasyon',
    secondaryButtonText_en: 'Documentation',
    mockRows: [],
  },

  stats: {
    stats: [
      {
        title: 'AKTİF PERSONEL',
        title_en: 'ACTIVE PERSONNEL',
        value: '250+',
        value_en: '250+',
        subText: '+12',
        subText_en: '+12',
      },
      {
        title: 'UYUM ORANI',
        title_en: 'COMPLIANCE RATE',
        value: '%98',
        value_en: '98%',
        subText: '+5',
        subText_en: '+5',
      },
      {
        title: 'EĞİTİM TAMAMLAMA',
        title_en: 'TRAINING COMPLETION',
        value: '%100',
        value_en: '100%',
        subText: '+2',
        subText_en: '+2',
      },
    ],
  },

  features: {
    Title: 'Temel Personel Özellikleri',
    Title_en: 'Core Personnel Features',
    description: '',
    description_en: '',
    cards: [
      {
        icon: 'manage_accounts',
        title: 'Rol ve Sorumluluklar',
        title_en: 'Roles & Responsibilities',
        description:
          'Her çalışana özgü görev tanımları ve güvenlik sorumluluklarını atayın, dijital olarak onaylayın.',
        description_en:
          'Assign job descriptions and security responsibilities unique to each employee, and approve them digitally.',
      },
      {
        icon: 'school',
        title: 'Eğitim ve Farkındalık',
        title_en: 'Training & Awareness',
        description:
          'Siber güvenlik farkındalık eğitimlerini otomatik planlayın, sertifikasyon süreçlerini anlık takip edin.',
        description_en:
          'Automatically schedule cybersecurity awareness trainings and track certification processes in real time.',
      },
      {
        icon: 'lock_person',
        title: 'Erişim Kontrolü',
        title_en: 'Access Control',
        description:
          'Pozisyon bazlı yetkilendirme (RBAC) ile veri erişimini minimuma indirin ve denetimleri kolaylaştırın.',
        description_en:
          'Minimize data access with role-based access control (RBAC) and simplify audits.',
      },
    ],
  },

  preHire: {
    baslik: 'İşe Alım Öncesi Güvenlik Taramaları',
    baslik_en: 'Pre-Employment Security Screenings',
    aciklama:
      'İşe alım öncesinde adayların geçmiş bilgilerinin doğrulanması ve güvenlik taramalarının yapılması, riskleri minimize etmek için kritik önem taşımaktadır.',
    aciklama_en:
      'Verifying candidate background information and conducting security screenings before hiring is critically important for minimizing risks.',
    ikonluKartlar: [
      { icon: 'assignment_ind', label: 'Özgeçmiş Doğrulama', label_en: 'CV Verification' },
      { icon: 'gavel', label: 'Adli Sicil Kaydı', label_en: 'Criminal Record Check' },
      { icon: 'verified', label: 'Referans Kontrolü', label_en: 'Reference Check' },
      { icon: 'description', label: 'Gizlilik Sözleşmesi', label_en: 'NDA' },
    ],
    maddeler: [
      {
        Title: 'Detaylı özgeçmiş ve referans doğrulama iş akışları.',
        title_en: 'Detailed CV and reference verification workflows.',
      },
      {
        Title: 'Adli sicil ve eğitim sertifikası kontrolü takibi.',
        title_en: 'Criminal record and education certificate verification tracking.',
      },
      {
        Title: 'NDA (Gizlilik Sözleşmesi) yönetimi ve dijital imza.',
        title_en: 'NDA management and digital signature.',
      },
    ],
  },

  offboarding: {
    baslik: 'İşten Ayrılma ve Değişiklik Süreçleri',
    baslik_en: 'Offboarding & Role Change Processes',
    aciklama:
      'Çalışanlar işten ayrıldığında veya görev değişikliği yaptığında, varlıklara erişimin zamanında kaldırılması ve ekipman iadelerinin takibini otomatikleştirin.',
    aciklama_en:
      'When employees leave or change roles, automate the timely removal of asset access and tracking of equipment returns.',
    kartlar: [
      {
        icon: 'no_accounts',
        title: 'Hesap Kapatma',
        title_en: 'Account Deactivation',
        description: 'Tüm dijital yetkilerin anında iptali.',
        description_en: 'Instant revocation of all digital permissions.',
      },
      {
        icon: 'inventory',
        title: 'Varlık İadesi',
        title_en: 'Asset Return',
        description: 'Donanım ve yazılım envanter takibi.',
        description_en: 'Hardware and software inventory tracking.',
      },
    ],
    checklistBaslik: 'İşten Ayrılma Kontrol Listesi',
    checklistBaslik_en: 'Offboarding Checklist',
    checklistItems: [
      { text: 'E-posta Hesabını Pasife Al', text_en: 'Deactivate Email Account', tamamlandi: true },
      { text: 'VPN ve Cloud Erişimini Kes', text_en: 'Revoke VPN & Cloud Access', tamamlandi: true },
      { text: 'Şirket Laptopunu Teslim Al', text_en: 'Collect Company Laptop', tamamlandi: false },
      { text: 'Giriş Kartını İptal Et', text_en: 'Cancel Access Card', tamamlandi: false },
    ],
  },

  awareness: {
    baslik: 'Güvenlik Farkındalığı Programı',
    baslik_en: 'Security Awareness Program',
    aciklama:
      'En zayıf halkayı en güçlü savunma hattına dönüştürün. Çalışanlarınıza düzenli eğitimler sunun ve performanslarını ölçün.',
    aciklama_en:
      'Turn the weakest link into your strongest line of defense. Provide regular training to your employees and measure their performance.',
    kartlar: [
      {
        icon: 'quiz',
        title: 'İnteraktif Testler',
        title_en: 'Interactive Tests',
        description: 'Her eğitim sonrası otomatik sınav ve değerlendirme.',
        description_en: 'Automatic exams and evaluations after each training.',
      },
      {
        icon: 'phishing',
        title: 'Oltalama Simülasyonları',
        title_en: 'Phishing Simulations',
        description: "Gerçekçi phishing testleri ile personelin savunmasını test edin.",
        description_en: "Test your personnel's defenses with realistic phishing simulations.",
      },
    ],
    skor: 85,
    tamamlamaOrani: 85,
    skorEtiketi: 'CANLI',
    skorEtiketi_en: 'LIVE',
  },

  cta: {
    Title: 'Personel Güvenliğini Şansa Bırakmayın',
    Title_en: "Don't Leave Personnel Security to Chance",
    Description:
      'RUZY ile ISO 27001 uyumluluk sürecinizi hemen başlatın ve personel yönetiminde tam kontrol sağlayın.',
    Description_en:
      'Start your ISO 27001 compliance process with RUZY right away and gain full control over personnel management.',
    primaryButtonText: 'Şimdi Başlayın',
    primaryButtonText_en: 'Get Started Now',
    secondaryButtonText: 'Uzmanla Görüşün',
    secondaryButtonText_en: 'Talk to an Expert',
  },
};

export default DEFAULT_PERSONEL_DATA;